var _rect, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPhoneFrame = function SvgPhoneFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 322 659",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 321,
    height: 658,
    rx: 38.5,
    stroke: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 15.5,
    width: 294,
    height: 628,
    rx: 38.5,
    stroke: "#fff",
    strokeOpacity: 0.25
  })));
};

export default SvgPhoneFrame;